import Summary from './Summary';

export default Summary
export { Summary as Base }